import axios from "axios";
import { cmsHeaders, headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchHomeSliders = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-slider?sort=sort_order:asc`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchManagerMessage = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/manager-message?sort=created_at:desc`,
      {
        headers: cmsHeaders,
      },
    );
    return response.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchMissionVision = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-mission-vision`,
      {
        headers: cmsHeaders,
      },
    );
    return response.data.slice(-2);
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};
export const fetchCraftsmanshipSlider = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-craftsmanship-slider?sort=sort_order:asc`,
      {
        headers: cmsHeaders,
      },
    );
    return response.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};
export const fetchOffers = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/bay-berry-special-offers?populate=*`,
      { headers },
    );
    return response.data.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};
export const fetchTestimonials = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-testimonial?sort=sort_order:asc`,
      {
        headers: cmsHeaders,
      },
    );
    return response.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchHighlightsTitle = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/highlights-section-title`,
      {
        headers: cmsHeaders,
      },
    );
    return response.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchReviewTitle = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/review-section-title`,
      {
        headers: cmsHeaders,
      },
    );
    return response.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};
